module.exports = __webpack_public_path__ + "img/icon-message-arrow-active.d379b2de.svg";